export enum Messages {
  notAutorized = 'Usuario no se encuentra registrado.',
  notAutorizedModule = 'Debe comunicar al administrador del sistema para que asigne los permisos sobre este módulo.',
  notAutorizedLogin = 'Usuario o contraseña incorrecta, favor verificar.',
  inserted = 'Operación realizada satisfactoriamente.',
  deleted = 'El registro se ha eliminado sastifactoriamente.',
  defaultError = 'En estos momentos no podemos procesar su solicitud, comuniquese con el administrador del sistema.',
  areYouSureSave = '¿Esta seguro que desea guardar este registro?',
  areYouSureDelete = '¿Esta seguro que desea eliminar este registro?',
  InvalidImageType = 'El formato del archivo es inválido, debe elegir un archivo con formato: .jpeg, .jpg, .png, .gif',
  invalidImageSize = 'Debe adjuntar una foto no mayor a los 5mb.',
  allReadyExistLocalty = 'Este sector o localidad ya se encuentra en la lista',
  mustSelectBranch = 'Debe seleccionar una sucursal',
  mustSelectRestaurant = 'Debe seleccionar el Restaurante',
  mustCheckConnection = 'No hay conexión con el servidor, compruebe su conexión a internet',
}
